<div class="wrapper-parent p-4">
    <div class="justify-content-start d-flex align-items-center" (click)="goBack()">
        <div class="back-btn d-flex align-items-center" style="cursor: pointer;">
            <fa-icon class="icon-go-back" [icon]='faChevronLeft'></fa-icon>
            <p class="m-0">Volver</p>
        </div>
    </div>
    <div class="calendar-wrapper" *ngIf="loaded">
        <div class="container-hours-dates">
            <div class="btn-month-wrapper mb-4 mt-4 d-flex justify-content-between">
                <div class="btn-month next-month" (click)="navigate(dp,-1)" style="cursor: pointer;"> <fa-icon class="icon-month"
                        [icon]='faChevronLeft'></fa-icon></div>
                <div class="btn-month prev-month" (click)="navigate(dp,1)" style="cursor: pointer;"> <fa-icon class="icon-month"
                        [icon]='faChevronRight'></fa-icon></div>
            </div>
            <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1" [dayTemplate]="t"
                outsideDays="hidden" (dateSelect)="changeDateSelected($event)" [minDate]="minDate" navigation="none">
                <ng-template #t let-date let-focused="focused">
                    <span class="custom-day-event" [class.focused]="hoveredDate != null"
                        [class.select-day]="date == selectedDate" [class.disabled]="dayDisabled(date)"
                        [class.focused]="isHovered(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        <span class="inside-day-event" [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                    </span>
                </ng-template>
            </ngb-datepicker>
        </div>

    </div>
    <div class="btn-primary btn-select-date" style="cursor: pointer;" *ngIf="selectedDate!=null" (click)="goTickets()">
        <p class="p-4">Siguiente</p>
    </div>

</div>
